module.exports = __webpack_public_path__ + "static/media/imageEMAR.6eadd4f5.webp";